import * as React from "react";

import { useReactMyBagInitialState } from "../providers";

export const ThankYou: React.FunctionComponent = () => {
  const { initialState } = useReactMyBagInitialState();
  const { orderId, orderEmail } = initialState || {};

  const handlePrintThisPage: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback(() => {
      window.print();
    }, []);
  return (
    <section className="thank-you-your-order-is-being-prepared">
      <h1>{`Thank you! Your order is being prepared`}</h1>

      <div className="your-reference-number">
        <p>{`Your Reference Number`}</p>
        <h3>{`${orderId}`}</h3>
      </div>

      <div className="confirmations">
        <p>{`A confirmation email will be sent shortly to`}</p>
        <p className="billing-email">{`${orderEmail}`}</p>
        <p className="giftcards">{`Any e-gift cards you purchased will be sent within one hour.`}</p>
      </div>

      <div className="actions">
        <button
          className="print-this-page"
          onClick={handlePrintThisPage}
        >{`PRINT THIS PAGE`}</button>
        <a href="/">
          <button>{`CONTINUE SHOPPING`}</button>
        </a>
      </div>
    </section>
  );
};
